import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 10H9.5V13H6.5V15H9.5V18H11.5V15H14.5V13H11.5V10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 22H16.5C17.603 22 18.5 21.103 18.5 20V8C18.5 6.897 17.603 6 16.5 6H4.5C3.397 6 2.5 6.897 2.5 8V20C2.5 21.103 3.397 22 4.5 22ZM4.5 8H16.5L16.502 20H4.5V8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 2H8.5V4H20.5V16H22.5V4C22.5 2.897 21.603 2 20.5 2Z",
			fill: "currentColor"
		})
	]
});
export default SvgDuplicate;
